
import React, { useState, useEffect } from "react";
import { Button, LoadingSpinner } from "../Common.jsx";
import { DynamicIcon } from "../icons.jsx";
import { apiFetch } from "../../api/index.js";

export default function PlanSelectionForm({ token, onSelect, selectedPlanId }) {
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        apiFetch("/plans", token)
            .then(res => setPlans(Array.isArray(res) ? res : []))
            .catch(err => console.error("Failed to load plans:", err))
            .finally(() => setLoading(false));
    }, [token]);

    if (loading) return <LoadingSpinner />;

    return (
        <div className="space-y-6">
            <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white">Select a Plan</h3>
                <p className="text-gray-500 mt-2">Choose the best plan to get started. You can customize details later.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                {plans.map((p) => {
                    const isSelected = selectedPlanId === p.id;
                    return (
                        <div key={p.id}
                            onClick={() => onSelect(p)}
                            className={`relative bg-white dark:bg-gray-800 rounded-2xl shadow-lg hover:shadow-xl transition-all border cursor-pointer group flex flex-col overflow-hidden ${isSelected ? "border-2 border-primary ring-4 ring-primary/10" : "border-gray-100 dark:border-gray-700 hover:border-primary/50"}`}
                        >
                            {isSelected && (
                                <div className="absolute top-0 inset-x-0 h-1.5 bg-primary z-10" />
                            )}
                            {isSelected && (
                                <div className="absolute top-4 right-4 bg-primary text-white p-1.5 rounded-full shadow-md z-20 animate-fade-in">
                                    <DynamicIcon name="Check" className="w-4 h-4" />
                                </div>
                            )}
                            {/* Header Gradient */}
                            {!isSelected && <div className="h-1 bg-gradient-to-r from-gray-200 to-gray-300 dark:from-gray-700 dark:to-gray-600" />}

                            <div className="p-6 flex-1 flex flex-col pt-8">
                                <div className="flex justify-between items-start mb-6">
                                    <div className="flex items-center gap-2">
                                        <h3 className="text-xl font-bold text-gray-900 dark:text-white leading-tight flex items-center gap-2">
                                            {p.name}
                                        </h3>
                                    </div>
                                    <div className="text-right leading-tight">
                                        <span className="text-2xl font-extrabold text-gray-900 dark:text-white">
                                            ${p.price}
                                        </span>
                                        <span className="text-xs text-gray-500 font-medium ml-1">/mo</span>
                                    </div>
                                </div>

                                <div className="flex flex-row items-center justify-between text-sm font-medium bg-gray-50 dark:bg-gray-700/50 rounded-lg p-3 mb-6">
                                    <span>{p.storage} GB</span>
                                    <span className="text-gray-300 dark:text-gray-600">|</span>
                                    <span>{p.apiCalls} Calls</span>
                                    <span className="text-gray-300 dark:text-gray-600">|</span>
                                    <span>{p.compute}</span>
                                </div>

                                <div className="mt-auto">
                                    <Button
                                        variant={isSelected ? "primary" : "secondary"}
                                        className="w-full justify-center"
                                        onClick={(e) => { e.stopPropagation(); onSelect(p); }}
                                    >
                                        {isSelected ? "Selected" : "Select Plan"}
                                    </Button>
                                </div>

                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
